<div class="layout-controls">
  <span class="layout-label">{{ 'translations.collections.layoutView' | transloco }}</span>
  <ptl-view-toggle
    [options]="viewOptions"
    [value]="selectedLayoutView"
    [groupLabel]="'translations.collections.layoutView' | transloco"
    (valueChange)="onLayoutViewChange($event)"
  ></ptl-view-toggle>
</div>
